/**
 * Purpose: Credit tier and credit score related selectors.
 */

// libraries
import type { CreditScoreSource, IOffer, OfferType } from '@makemydeal/dr-platform-types';
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
// interfaces/types
import type { CreditTierScoreOnly } from '../types/commonTypes';

// utils
import {
    getCreditTierById,
    getCurrentOfferType,
    getOffer,
    getOfferDetails,
    getPenciledInputs,
    getSelectedCreditTierScore
} from './offerNodeSelectors';

export function getSelectedCreditTierScoreByType(state: OfferReduxBaseState, offerType: OfferType): CreditTierScoreOnly {
    const offerDetails = getOfferDetails(state, offerType);
    const selectedCreditTierId = offerDetails.creditTier;

    const creditTier = getCreditTierById(state, selectedCreditTierId);

    return { score: creditTier?.score };
}

export function getSelectedCreditTierLabelDescriptor(state: OfferReduxBaseState): string {
    const offerDetails = getOfferDetails(state, getCurrentOfferType(state));
    const selectedCreditTierId = offerDetails.creditTier;
    const creditTier = getCreditTierById(state, selectedCreditTierId);
    return creditTier.name;
}

export function getSelectedCreditTierLabelDescriptorByType(state: OfferReduxBaseState, offerType: OfferType): string {
    const offerDetails = getOfferDetails(state, offerType);
    const selectedCreditTierId = offerDetails.creditTier;
    const creditTier = getCreditTierById(state, selectedCreditTierId);
    return creditTier.name;
}

export function getShopperCreditScore(state: OfferReduxBaseState) {
    const creditTier = getSelectedCreditTierScore(state);
    const high = creditTier.score.high;
    const low = creditTier.score.low;

    return Math.ceil((high - low) / 2 + low);
}

export function getManualCreditScore(state: OfferReduxBaseState): number | undefined {
    const penciledInputs = getPenciledInputs(state);
    return penciledInputs?.manualCreditScore;
}

export function getCreditScore(state: IOffer) {
    return state.creditScore;
}

export function getCreditScoreSource(state: OfferReduxBaseState): CreditScoreSource | undefined {
    return getOffer(state).creditScoreSource;
}

export function getSelectedCreditTierId(state: OfferReduxBaseState): string | undefined {
    const offerDetails = getOfferDetails(state, getCurrentOfferType(state));
    const selectedCreditTierId = offerDetails.creditTier;
    return selectedCreditTierId;
}
